import React from 'react'

export const SettingsContext = React.createContext({})

export const SettingsProvider = SettingsContext.Provider
